import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../utils/api';

// Query keys
const CMS_PAGES_QUERY_KEY = 'cmsPages';

// Custom hook for fetching Terms page
export const useTermsPage = () => {
  return useQuery({
    queryKey: [CMS_PAGES_QUERY_KEY, 'terms'],
    queryFn: () => apiClient.cmsPages.getTerms(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Custom hook for updating Terms page
export const useUpdateTermsPage = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data) => apiClient.cmsPages.updateTerms(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CMS_PAGES_QUERY_KEY, 'terms'] });
    },
  });
};

// Custom hook for fetching Privacy page
export const usePrivacyPage = () => {
  return useQuery({
    queryKey: [CMS_PAGES_QUERY_KEY, 'privacy'],
    queryFn: () => apiClient.cmsPages.getPrivacy(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Custom hook for updating Privacy page
export const useUpdatePrivacyPage = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data) => apiClient.cmsPages.updatePrivacy(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CMS_PAGES_QUERY_KEY, 'privacy'] });
    },
  });
};

// Custom hook for fetching FAQs page
export const useFaqsPage = () => {
  return useQuery({
    queryKey: [CMS_PAGES_QUERY_KEY, 'faqs'],
    queryFn: () => apiClient.cmsPages.getFaqs(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Custom hook for updating FAQs page
export const useUpdateFaqsPage = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data) => apiClient.cmsPages.updateFaqs(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CMS_PAGES_QUERY_KEY, 'faqs'] });
    },
  });
};

// Custom hook for fetching About page
export const useAboutPage = () => {
  return useQuery({
    queryKey: [CMS_PAGES_QUERY_KEY, 'about'],
    queryFn: () => apiClient.cmsPages.getAbout(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Custom hook for updating About page
export const useUpdateAboutPage = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data) => apiClient.cmsPages.updateAbout(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CMS_PAGES_QUERY_KEY, 'about'] });
    },
  });
};

// Custom hook for fetching Settings page
export const useSettingsPage = () => {
  return useQuery({
    queryKey: [CMS_PAGES_QUERY_KEY, 'settings'],
    queryFn: () => apiClient.cmsPages.getSettings(),
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

// Custom hook for updating Settings page
export const useUpdateSettingsPage = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: (data) => apiClient.cmsPages.updateSettings(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [CMS_PAGES_QUERY_KEY, 'settings'] });
    },
  });
}; 